import React, { useEffect, useState } from 'react';

export default function PWAInstall() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    // Verifica daca e deja instalata
    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('[PWA] Deja instalată (display-mode: standalone)');
      setInstalled(true);
      return;
    }
    console.log('[PWA] Nu e instalată. Aștept evenimentul beforeinstallprompt...');

    const handler = (e) => {
      console.log('[PWA] beforeinstallprompt DECLANȘAT — butonul ar trebui să apară acum');
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => {
      console.log('[PWA] appinstalled — aplicația a fost instalată cu succes');
      setInstalled(true);
    });

    // Diagnostic: verificam daca service worker-ul e inregistrat
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        console.log('[PWA] Service workers înregistrați:', regs.length, regs);
      });
    } else {
      console.log('[PWA] navigator.serviceWorker NU este disponibil în acest browser');
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // Nu afisa daca e deja instalata sau daca nu e suportat
  if (installed || !prompt) return null;

  const install = async () => {
    try {
      prompt.prompt();
      const result = await prompt.userChoice;
      console.log('[PWA] Răspuns utilizator:', result.outcome);
      if (result.outcome === 'accepted') setInstalled(true);
      setPrompt(null);
    } catch(e) {
      console.error('[PWA] Eroare la instalare:', e);
    }
  };

  return (
    <button onClick={install}
      style={{background:'#27ae60',color:'white',border:'none',borderRadius:4,
        padding:'5px 10px',cursor:'pointer',fontSize:12,fontWeight:'bold',whiteSpace:'nowrap'}}
      title="Instalează aplicația pe dispozitiv">
      📲 Instalează
    </button>
  );
}
